<template>
<section class="font-poppins">
    <section class="flex md:flex-col">
        <div>

        <AdminDashboardNav/>
        </div>
        <section class=" w-screen md:pl-1 md:pr-1">
            <section class="mt-6">
                <div class=" flex justify-between pl-10 pr-10 pt-5 md:flex-col-reverse">
                    <div class="md:mt-6">
                        <GetDate/>
                        <p class="text-blue-700 font-bold text-2xl md:text-sm">DASHBOARD</p>
                    </div>

                    <div class=" mr-10">
                        <Notification/>
                    </div>
                </div>
            </section>


            <section class=" mt-10 flex justify-around md:flex-col">
                <div class="border md:w-full w-1/2">
                    <bar-chart class="bg-gray-50" :data="chartData" label="Total Sales Report"></bar-chart>

                    <div class="flex mt-10 text-sm md:flex-col">
                        <div class="flex w-1/2 md:w-full ml-3 p-3 bg-gray-100">
                            <img src="../assets/orders.svg" alt="icon">
                            <div class="ml-4">
                                <p>Total completed <br>Orders</p>
                            </div>
                            <p class="ml-6 text-xl font-semibold">{{totalDeliveredOrders}}</p>
                        </div>

                        <div class="flex w-1/2 md:w-full md:mt-2 ml-3 p-3 bg-gray-100">
                            <img src="../assets/orders-on.svg" alt="icon">
                            <div class="ml-4">
                                <p>Total ongoing <br>Orders</p>
                            </div>
                            <p class="ml-6 text-xl font-semibold">{{totalOngoingOrders}}</p>
                        </div>
                        
                    </div>
                </div>


                <!-- -------------------------- WEEKLY TOTAL PACKAGES, HAULAGE, BOOK A RIDE, ORDERS SECTION---------------- -->

                <section >
                    <div class=" ml-8 text-sm md:mt-4 md:ml-0">
                        <div class="flex justify-between">
                            <div class="flex">
                                <img src="../assets/analysis-arrow.png" alt="arrow">
                                <p class="ml-4">Data</p>
                            </div>

                            <div class="flex">
                                <p>Show:</p>
                                <select @change="showReport($event)"  class="text-blue-600 outline-none" name="report" id="report">
                                    <option value="weekly">Weekly</option>
                                    <option value="monthly">Monthly</option>
                                </select>
                            </div>
                            
                        </div>

                        <div v-if="weeklyReport" class="bg-gray-100 p-8 mt-4">
                            <WeeklyReport/>
                        </div>

                    <!-- ------------MONTHLY TOTAL ORDERS - ------------ -->

                        <div v-if="monthlyReport" class="bg-gray-100 p-8 mt-4">
                            <MonthlyReport/>
                        </div>
                    </div>
                </section>
            </section>

            <!-- -------------PIE CHART SECTION------------------------- -->

            <section class=" mt-10 flex pl-10 pr-10 lg:flex-col pb-4 ">
                <div>
                    <!--------- PENDING APPROVALS----------- -->
                    <div class="flex border justify-between p-2">
                        <PendingApprovals :pendingApprovals="totalPendingRiders" :pendingDsos="totalPendingDsos"/>
                    </div>  

                    <router-link to="/orders/income">
                        <PieChart/>
                    </router-link>  
                </div>


                <!-- --------------------------------TRACKING PROGRESS ------------------------------------->
                <div>
                    <TrackOrder/>
                </div>
                
            </section>      
        </section>        
    </section>
</section>
</template>

<script>
import axios from 'axios'
import AdminDashboardNav from '../AdminDashboardNav.vue';
import GetDate from '../GetDate.vue';
import Notification from '../Notification.vue';
import WeeklyReport from './WeeklyReport.vue';
import MonthlyReport from './MonthlyReport.vue';
import PendingApprovals from './PendingApprovals.vue';
import PieChart from './PieChart.vue';
import TrackOrder from './TrackOrder.vue';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    components: {
        AdminDashboardNav,
        GetDate,
        Notification,
        WeeklyReport,
        MonthlyReport,
        PendingApprovals,
        PieChart,
        TrackOrder
    },
    data() {
        return {
            userId: localStorage.getItem('userId'),
            chartData: {},
            token: localStorage.getItem("token"),

            totalDeliveredOrders: "",
            totalOngoingOrders : "",

            totalPendingRiders : "",
            totalPendingDsos : "",
            weeklyReport: true,
            monthlyReport : false,

            pieChart: [
                ['Send a Package', parseFloat(this.totalPackage)],
                ['Buy for me', parseFloat(this.totalBuyForMe)],
                ['Haulage', 120],
                ['Rides', 120]
            ]
        }
    },

    mounted() {
        this.getMonthlyChart();
        this.getOngoingOrders();
        this.getDeliveredOrders();
        this.getPendingRiders();
        this.getPendingDsos();
        this.networkError();
    },

    methods: {
        showReport(event) {
            if(event.target.value === "weekly") {
                this.weeklyReport = true
                this.monthlyReport = false
            } else if(event.target.value === "monthly") {
                this.monthlyReport = true
                this.weeklyReport = false
            }
        },

        formMonthlyChart(responseArray){
               let chartObj = {};
                for(let i=0; i < responseArray.length; i++){
                    let months = responseArray[i]['_id'];
                    let monthly_chart = "";
                    switch(months) {
                    case 1:
                        monthly_chart = "Jan";
                        break;
                    case 2:
                        monthly_chart = "Feb";
                        break;
                    case 3:
                        monthly_chart = "Mar";
                        break;
                    case 4:
                        monthly_chart = "April";
                        break;
                    case 5:
                        monthly_chart = "May";
                        break;
                    case 6:
                        monthly_chart = "June";
                        break;
                    case 7:
                        monthly_chart = "July";
                        break;
                    case 8:
                        monthly_chart = "Aug";
                        break;
                    case 9:
                        monthly_chart = "Sept";
                        break;
                    case 10:
                        monthly_chart = "Oct";
                        break;
                    case 11:
                        monthly_chart = "Nov";
                        break;
                    case 12:
                        monthly_chart = "Dec";
                        break;
                    default:
                        "-"
                    }
                    chartObj[monthly_chart] = responseArray[i].totalOrders
                    // let sum = 0
                    // sum += responseArray[i]['totalOrders']
                    // this.total = sum
                }
            return chartObj;
        },

        getOngoingOrders() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/dashboard/orders?status=processing`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                let total = response.data.data
                this.totalOngoingOrders = total.total
            })
            .catch((error) => {
                console.log(error)
            })
        },

        getDeliveredOrders() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/dashboard/orders?status=completed`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                let total = response.data.data
                this.totalDeliveredOrders = total.total
            })
            .catch((error) => {
                console.log(error)
            })
        },

        
        
        getPendingRiders() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/riders?sortBy=status&status=pending`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                let pendingRiders = response.data.data.results
                this.totalPendingRiders = pendingRiders.length
            })
            .catch((error) => {
                console.log(error)
            })
        },
         getPendingDsos() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/dsos?sortBy=status&status=pending`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                let pendingDsos = response.data.data.results
                this.totalPendingDsos = pendingDsos.length
            })
            .catch((error) => {
                console.log(error)
            })
        },
        getMonthlyChart() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/dashboard/charts/${this.userId}?timeFrame=monthly`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                var responseArray = response.data.data;
                this.chartData = this.formMonthlyChart(responseArray);
            })
            .catch((error) => {
                console.log(error)
            })
        },

        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        }
    }
    
}
</script>